import React from "react";

import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { DeleteIcon } from "../../../components/common/iconography";

const useStyles = makeStyles((theme) => ({
  icon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

export const CarrierCreateHelp = () => (
  <>
    <Typography variant="subtitle1">
      Creating a new Carrier company record. This establishes a carrier business
      in the system. Individual users can then be added to this carrier company
      to access the platform.
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>Business Name: </strong> The name of the carrier company. This
          is the official business name that will be displayed throughout the
          system.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Email: </strong> Primary contact email for the carrier
          company. This email will be used for company-wide communications and
          can be used as the default contact for the carrier.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Phone: </strong> Primary contact phone number for the carrier
          company. Optional — for record keeping and company communications.
        </Typography>
      </li>
    </ul>
  </>
);

export const CarrierEditHelp = () => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="subtitle1">
        Edit carrier company information. This updates the basic company details
        for the carrier.
      </Typography>
      <ul>
        <li>
          <Typography>
            <strong>Business Name: </strong> The official name of the carrier
            company. This can be updated if the company name changes.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Email: </strong> Primary contact email for the carrier
            company. This can be updated for company communications.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Phone: </strong> Primary contact phone number for the
            carrier company. Optional, and can be updated or cleared at any
            time.
          </Typography>
        </li>
        <li>
          <Typography>
            <DeleteIcon className={classes.icon} />
            <strong> DELETE: </strong>
            Removes the carrier company from the system. This will also remove
            access for all users associated with this carrier.
          </Typography>
        </li>
      </ul>
    </>
  );
};
